import { FundingPolicyType, fundingPolicyTypeDefs } from '@shared';
import { openIntercomChat } from '@client/util/intercomUtil';
import { useSupportChatAllowed } from '@client/hooks/useSupportChat';
import { WarningInfoDisclaimer } from './WarningInfoDisclaimer';

export function UnverifiedModelingDisclaimer({ policyType }: { policyType: FundingPolicyType }) {
  const label = fundingPolicyTypeDefs[policyType]?.label ?? 'This product';
  const isSupportChatAllowed = useSupportChatAllowed();

  return (
    <WarningInfoDisclaimer
      type="warning"
      bodyText={
        <p>
          <span className="font-semibold">Please note:</span> {label} is not yet fully supported by
          Waterlily&apos;s modeling logic, and Waterlily does not guarantee its accuracy. Depending
          on your specific policy&apos;s terms, the projected LTC coverage shown may not accurately
          reflect your actual benefits. You, not Waterlily, are responsible for verifying the modeled
          results against your policy documents.
          {isSupportChatAllowed && (
            <>
              {' '}
              If you have questions or would like to request full support for this policy type,{' '}
              <button
                type="button"
                onClick={openIntercomChat}
                className="font-medium underline"
              >
                contact us
              </button>
              .
            </>
          )}
        </p>
      }
    />
  );
}
